import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

// Translation stuff, see: https://github.com/ngx-translate/core
import { TranslateModule } from '@ngx-translate/core';

import * as fromContainers from './containers';
import * as fromEntryComponents from './entry-components';
import * as fromServices from '../../services';
import { reducers, effects } from './store';
import { PartialsModule } from '../../partials/partials.module';
import { HelpRoutingModule } from './help-routing.module';

@NgModule({
    providers: [...fromServices.services],
    imports: [
        CommonModule,
        PartialsModule,
        HelpRoutingModule,
        StoreModule.forFeature('HelpFeature', reducers),
        EffectsModule.forFeature(effects),
        TranslateModule.forChild({ extend: true })
    ],
    declarations: [...fromContainers.containers, ...fromEntryComponents.entryComponents],
    exports: [...fromContainers.containers]
})
export class HelpModule {}
